import { Tooltip } from "@mui/material";
import VerifiedIcon from "@mui/icons-material/Verified";
import ErrorOutlineIcon from "@mui/icons-material/ErrorOutline";
import { ElementType } from "react";

interface EmailVerificationStatusProps {
  isVerified?: boolean;
  verifiedIcon?: ElementType;
}

const EmailVerificationStatus: React.FC<EmailVerificationStatusProps> = ({
  isVerified,
  verifiedIcon: VerifiedIconComponent = VerifiedIcon,
}) => {
  if (isVerified) {
    return (
      <Tooltip title="Email is verified!" placement="top" arrow>
        <VerifiedIconComponent color="success" fontSize="small" />
      </Tooltip>
    );
  }

  return (
    <Tooltip title="Email is not verified yet!" placement="top" arrow>
      <ErrorOutlineIcon sx={{ color: "#FFAA00" }} fontSize="small" />
    </Tooltip>
  );
};

export default EmailVerificationStatus;
